export enum StartDateTypeEnum {
    Set = 'Set Start Date',
    Change = 'Change Start Date',
}
